const onGet = ( status ) => {

    switch ( status ) {
        case 404:
            return {
                status: status,
                message: "recuperare il cliente: il cliente non esiste",
                redirectRoute: '/clienti/'
            }    
        case 422:
            return {
                status: status,
                message: "recuperare il cliente: l' uuid cliente non è corretto",
            } 
        default:
            return null;
    }

}

export default onGet;